
import { Task } from "../types/tasks";

// Initial mock tasks data with comments and change requests
export const initialTasks: Task[] = [
  {
    id: "1",
    title: "Clean art supplies",
    description: "Organize and clean all art supplies in the main storage closet",
    status: "pending",
    priority: "medium",
    category: "classroom",
    dueDate: "May 15, 2025",
    estimatedTime: "1.5 hours",
    assignee: {
      id: "1",
      name: "Sarah Johnson",
      avatar: "https://i.pravatar.cc/150?u=sarah"
    },
    comments: [
      {
        id: "c1",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "I'll help with this on Thursday afternoon if that works for you.",
        createdAt: "2025-05-08T14:22:00Z"
      },
      {
        id: "c2",
        authorId: "3",
        authorName: "Emily Rodriguez",
        authorAvatar: "https://i.pravatar.cc/150?u=emily",
        content: "Don't forget to check the paint supplies too!",
        createdAt: "2025-05-09T09:15:00Z"
      }
    ],
    changeRequests: [
      {
        id: "cr1",
        taskId: "1",
        requestType: "extend",
        requesterId: "1",
        details: "Need additional time due to unexpected inventory check.",
        status: "pending",
        createdAt: "2025-05-10T11:30:00Z"
      }
    ],
    hasPendingRequests: true
  },
  {
    id: "2",
    title: "Update emergency contact forms",
    description: "Check and update all emergency contact forms for new families",
    status: "in_progress",
    priority: "high",
    category: "administrative",
    dueDate: "May 12, 2025",
    estimatedTime: "2 hours",
    assignee: {
      id: "2",
      name: "Michael Chen",
      avatar: "https://i.pravatar.cc/150?u=michael"
    },
    comments: [],
    changeRequests: [
      {
        id: "cr2",
        taskId: "2",
        requestType: "reassign",
        requesterId: "2",
        details: "I have a conflicting appointment on the due date. Can someone else take this task?",
        status: "pending",
        createdAt: "2025-05-09T16:45:00Z"
      }
    ],
    hasPendingRequests: true
  },
  {
    id: "3",
    title: "Fix playground swing",
    description: "Repair the broken swing in the outdoor playground",
    status: "completed",
    priority: "high",
    category: "facilities",
    dueDate: "May 10, 2025",
    estimatedTime: "1 hour",
    assignee: {
      id: "3",
      name: "Emily Rodriguez",
      avatar: "https://i.pravatar.cc/150?u=emily"
    },
    comments: [
      {
        id: "c3",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "The parts arrived this morning, so we should be good to go.",
        createdAt: "2025-05-07T11:42:00Z"
      },
      {
        id: "c4",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "I can help with the installation if needed.",
        createdAt: "2025-05-07T13:55:00Z"
      },
      {
        id: "c5",
        authorId: "3",
        authorName: "Emily Rodriguez",
        authorAvatar: "https://i.pravatar.cc/150?u=emily",
        content: "All fixed now! Children can use it again starting tomorrow.",
        createdAt: "2025-05-09T16:30:00Z"
      },
      {
        id: "c6",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "Great job, thank you!",
        createdAt: "2025-05-09T17:05:00Z"
      },
      {
        id: "c7",
        authorId: "3",
        authorName: "Emily Rodriguez",
        authorAvatar: "https://i.pravatar.cc/150?u=emily",
        content: "You're welcome! I also tightened up the other swings while I was at it.",
        createdAt: "2025-05-09T17:15:00Z"
      }
    ],
    changeRequests: [
      {
        id: "cr3",
        taskId: "3",
        requestType: "reassign",
        requesterId: "3",
        details: "This task was more complicated than expected. I suggest assigning a maintenance professional next time.",
        status: "approved",
        createdAt: "2025-05-08T10:15:00Z"
      }
    ],
    hasPendingRequests: false
  },
  {
    id: "4",
    title: "Prepare snacks for Friday",
    description: "Buy and prepare healthy snacks for Friday's class",
    status: "pending",
    priority: "medium",
    category: "classroom",
    dueDate: "May 14, 2025",
    estimatedTime: "1 hour",
    assignee: {
      id: "1",
      name: "Sarah Johnson",
      avatar: "https://i.pravatar.cc/150?u=sarah"
    },
    comments: [
      {
        id: "c8",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "I'm thinking of getting fruits and some whole grain crackers.",
        createdAt: "2025-05-10T14:22:00Z"
      }
    ],
    changeRequests: []
  },
  {
    id: "5",
    title: "Organize fundraising event",
    description: "Coordinate the annual spring fundraiser",
    status: "in_progress",
    priority: "high",
    category: "events",
    dueDate: "June 5, 2025",
    estimatedTime: "10 hours",
    assignee: {
      id: "3",
      name: "Emily Rodriguez",
      avatar: "https://i.pravatar.cc/150?u=emily"
    },
    comments: [
      {
        id: "c9",
        authorId: "3",
        authorName: "Emily Rodriguez",
        authorAvatar: "https://i.pravatar.cc/150?u=emily",
        content: "I've contacted several local businesses for sponsorship.",
        createdAt: "2025-05-05T09:30:00Z"
      },
      {
        id: "c10",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "The art auction items are ready whenever you need them.",
        createdAt: "2025-05-06T13:15:00Z"
      },
      {
        id: "c11",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "I've drafted the flyers and social media posts - will send for review today.",
        createdAt: "2025-05-07T11:20:00Z"
      },
      {
        id: "c12",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "The venue is confirmed for June 5th from 4-8pm.",
        createdAt: "2025-05-08T14:50:00Z"
      },
      {
        id: "c13",
        authorId: "3",
        authorName: "Emily Rodriguez",
        authorAvatar: "https://i.pravatar.cc/150?u=emily",
        content: "Great progress everyone! Let's meet next Tuesday to finalize details.",
        createdAt: "2025-05-09T16:05:00Z"
      },
      {
        id: "c14",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "Tuesday works for me. I'll have the volunteer schedule ready by then.",
        createdAt: "2025-05-09T16:45:00Z"
      },
      {
        id: "c15",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "I'll bring the budget report to discuss.",
        createdAt: "2025-05-09T17:30:00Z"
      }
    ],
    changeRequests: [
      {
        id: "cr4",
        taskId: "5",
        requestType: "extend",
        requesterId: "3",
        details: "Several sponsors need more time to confirm. Can we extend the preparation timeline?",
        status: "pending",
        createdAt: "2025-05-11T09:20:00Z"
      }
    ],
    hasPendingRequests: true
  },
  {
    id: "6",
    title: "Order new books",
    description: "Research and order new books for the reading corner",
    status: "pending",
    priority: "low",
    category: "classroom",
    dueDate: "May 25, 2025",
    estimatedTime: "2 hours",
    comments: [],
    changeRequests: []
  },
  {
    id: "7",
    title: "Schedule parent-teacher conferences",
    description: "Create schedule for upcoming parent-teacher conferences",
    status: "overdue",
    priority: "high",
    category: "administrative",
    dueDate: "May 5, 2025",
    estimatedTime: "3 hours",
    assignee: {
      id: "2",
      name: "Michael Chen",
      avatar: "https://i.pravatar.cc/150?u=michael"
    },
    comments: [
      {
        id: "c16",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "I'm working on this today - sorry for the delay!",
        createdAt: "2025-05-08T09:15:00Z"
      },
      {
        id: "c17",
        authorId: "1",
        authorName: "Sarah Johnson",
        authorAvatar: "https://i.pravatar.cc/150?u=sarah",
        content: "Please try to complete this by tomorrow - we need to send the invites out.",
        createdAt: "2025-05-08T11:30:00Z"
      },
      {
        id: "c18",
        authorId: "2",
        authorName: "Michael Chen",
        authorAvatar: "https://i.pravatar.cc/150?u=michael",
        content: "Will do - I'll have it ready by end of day.",
        createdAt: "2025-05-08T11:45:00Z"
      }
    ],
    changeRequests: [
      {
        id: "cr5",
        taskId: "7",
        requestType: "reassign",
        requesterId: "2",
        details: "I've been unable to complete this due to other urgent tasks. Can someone else take over?",
        status: "rejected",
        createdAt: "2025-05-07T15:30:00Z"
      },
      {
        id: "cr6",
        taskId: "7",
        requestType: "extend",
        requesterId: "2",
        details: "Need additional time to contact all parents for availability.",
        status: "pending",
        createdAt: "2025-05-09T08:45:00Z"
      }
    ],
    hasPendingRequests: true
  }
];
